// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutWorkDoneSection_wrapper__vKw2q","title":"AboutWorkDoneSection_title__VriKj","logo":"AboutWorkDoneSection_logo__u-AXC"};